/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/no-string-refs */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-plusplus */
/* eslint-disable default-case */
/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import { AccentButton, Confirmation, Icon as IconComp } from '@lyearn-team/frontend-components';
import Radium, { Style } from 'radium';
import $j from 'jquery';
import findIndex from 'lodash/findIndex';
import Truncate from 'react-truncate';
import * as DataService from 'helper/LearningSpaceServices/DataService';
import { getItemInfo } from 'components/ItemFetch';
import TextResponse from './TextResponse';
import FileResponse from './FileResponse';
import AudioResponse from './AudioResponse/AudioResponse';
import VideoResponse from './VideoResponse';
import QuizCard from './QuizCard';
import PictureResponse from './PictureResponse';
import SurveyOpinionResponse from './SurveyOpinionResponse';
import * as Colors from '../../../helper/Colors';
import Icon from '../../../../helper/Icon';
import ReactMediaPlayer from '../../../../components/ReactMediaPlayer/ReactMediaPlayer';

const kYourResponseLabel = 13.0;
const kQuestionFontSize = 13.0;
const kMarginBig = 32.0;
const kMarginSmall = 6.0;
const kBlack12 = 'rgba(0, 0, 0, 0.12)';
const kGray = '#767E86';
const kIconSize = 24.0;
const kRecommendedLabelFontSize = 8.0;

@Radium
class SubmissionItem extends Component {
  static propTypes = {
    submission: PropTypes.object.isRequired,
    position: PropTypes.number.isRequired,
    uploadResponse: PropTypes.func.isRequired
  };

  static contextTypes = {
    checkForSubmit: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state.selectedResponseType = this.getSelectedResponseType(props);
    if (
      typeof this.props.submission.response === 'string' &&
      this.props.submission.response !== '' &&
      this.props.submission.response
    ) {
      if (
        (this.state.selectedResponseType === 'SINGLE_SELECT' ||
          this.state.selectedResponseType === 'MULTIPLE_SELECT') &&
        parseInt(this.props.submission.response, 10) === -1
      ) {
        this.state.isResponseEntered = false;
      } else {
        this.state.isResponseEntered = true;
      }
    }
    this.readMoreIndexes = [];
    this.keyIndex = 0;
  }

  state = {
    selectedResponseType: '',
    isResponseEntered: false,
    showSubmittedText: false,
    cancelButtonHovered: false,
    responseEdited: false,
    deletingResponse: false,
    showTopRatedSubmissions: this.props.submission.response === '',
    showFeedbackPopup: true,
    readMore: true,
    topRatedResponses: []
  };

  async componentDidMount() {
    const peerGradable = this.props.questionObj.gradingScheme === 'PEER_GRADABLE';
    if (peerGradable) {
      const questionId = this.props.card.questionAnswers[0].pid;
      const responseObject = await DataService.fetchTopRatedResponses(questionId);
      const responseList = await responseObject.json();
      responseList.forEach(response => {
        response.answer.answerType = response.answer.answerType.toUpperCase();
      });
      this.setState({
        topRatedResponses: responseList
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.submission.response === 'string' &&
      nextProps.submission.response !== '' &&
      nextProps.submission.response
    ) {
      if (
        (this.state.selectedResponseType === 'SINGLE_SELECT' ||
          this.state.selectedResponseType === 'MULTIPLE_SELECT') &&
        parseInt(nextProps.submission.response, 10) === -1
      ) {
        this.state.isResponseEntered = false;
        this.state.deletingResponse = false;
      } else {
        this.state.isResponseEntered = true;
      }
    } else {
      this.state.isResponseEntered = false;
      this.state.deletingResponse = false;
    }
    if (this.props.submission.response === '' && nextProps.submission.response !== '') {
      this.setState({ showTopRatedSubmissions: false });
    } else if (this.props.submission.response === '' && nextProps.submission.response !== '') {
      this.setState({ showTopRatedSubmissions: true });
    }
    if (
      nextProps.cardId !== this.props.cardId ||
      this.props.submission.answerType !== nextProps.submission.answerType
    ) {
      this.state.selectedResponseType = this.getSelectedResponseType(nextProps);
    }
  }

  getSelectedResponseType(thisProps) {
    let props;
    if (thisProps) {
      props = thisProps;
    } else {
      props = this.props;
    }

    const isSecondaryResponseTypeAvailable =
      props.submission.answerTypeSecondary && props.submission.answerTypeSecondary.length > 0;
    if (!isSecondaryResponseTypeAvailable) {
      return props.submission.answerType;
    }
    if (props.submission.response) {
      return this.props.parseAnswerTypeFromResponse(props.submission);
    }

    return null;
  }

  responseEnterChange = entered => {
    this.context.checkForSubmit && this.context.checkForSubmit();
    this.setState({
      isResponseEntered: entered
    });
  };

  rerender = () => {
    this.setState({});
  };

  showTopRatedSubmissions = () => {
    this.setState(
      {
        showTopRatedSubmissions: !this.state.showTopRatedSubmissions
      },
      () => {
        $j('#CardWrapper video')
          .not('.ownSubmissionContainer video')
          .attr('controlsList', 'nodownload');
      }
    );
  };

  styles() {
    return {
      classBased: {
        '.assignmentCardContainer ul': {
          listStyleType: 'disc',
          listStylePosition: 'inside'
        },
        '.assignmentCardContainer ol': {
          listStyleType: 'decimal',
          listStylePosition: 'inside'
        },
        '.submittedResponse:hover span': {
          color: '#566068'
        },
        '.submittedResponse:hover svg g': {
          fill: '#566068'
        },
        '.responseTypeIcon:hover g': {
          fill: '#767e86'
        },
        '.criteriaLine': {
          marginBottom: '8px',
          position: 'relative',
          paddingLeft: '13px'
        },
        '.criteriaLine:last-child': {
          marginBottom: '0px'
        },
        '.criteriaLine:before': {
          content: '""',
          width: '6px',
          height: '6px',
          background: '#c8cfd6',
          display: 'flex',
          position: 'absolute',
          borderRadius: '50%',
          left: '0px',
          top: '5px'
        },
        '.questionText ul': {
          listStyleType: 'disc',
          listStylePosition: 'outside',
          paddingLeft: '20px'
        },
        '.questionText ul ul': {
          listStyleType: 'circle',
          listStylePosition: 'outside',
          paddingLeft: '20px'
        },
        '.questionText ul ul ul': {
          listStyleType: 'square',
          listStylePosition: 'outside',
          paddingLeft: '20px'
        },
        '.questionText ol, .questionText ol ol, .questionText ol ol ol': {
          listStyleType: 'decimal',
          listStylePosition: 'outside',
          paddingLeft: '20px'
        },
        '.responseTypeIcon': {
          transform: 'scale(0.8)',
          fill: 'rgb(177, 187, 195)'
        },
        '.responseTypeIcon:hover': {
          fill: '#767e86'
        }
      },
      container: {},
      innerContainer: {
        padding: '40px 0',
        margin: '0 0 10px 0',
        width: '100%',
        borderBottom: '1px solid #dbe2e8',
        position: 'relative'
      },
      noBorderBottom: {
        borderBottom: 'none'
      },
      separator: {
        backgroundColor: kBlack12,
        height: 1,
        alignSelf: 'stretch'
      },
      questionTitleLine: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      },
      questionNumber: {
        color: kGray,
        marginBottom: kMarginSmall
      },
      mainFont: {
        textTransform: 'uppercase',
        fontSize: kQuestionFontSize,
        lineHeight: '18px',
        fontWeight: '500',
        letterSpacing: '0.11px'
      },
      questionText: {
        fontSize: '15px',
        lineHeight: '20px',
        color: 'rgba(0 ,0,0,0.8)',
        letterSpacing: '0.12px',
        fontFamily: 'ProximaNova',
        paddingRight: '40px'
      },
      spaceBetween: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: kMarginBig
      },
      responseTypeWrapper: {
        width: '100%',
        marginBottom: '16px',
        display: 'table',
        verticalAlign: 'center'
      },
      multipleResponseTypeWrapper: {
        width: '100%',
        marginBottom: '16px',
        display: 'flex'
      },
      yourResponse: {
        fontSize: kYourResponseLabel,
        lineHeight: '18px',
        fontWeight: '500',
        color: kGray,
        letterSpacing: '0.11px',
        display: 'table-cell',
        textTransform: 'uppercase'
      },
      yourResponseFullWidth: {
        width: '100%'
      },
      yourResponseMargin10: {
        marginBottom: '10px'
      },
      yourReponseMargin25: {
        marginBottom: '20px'
      },
      feedbackWrapper: {
        width: '100%',
        padding: '11px 32px 12px 32px',
        backgroundColor: 'rgba(237, 240, 243, 0.6)',
        margin: '0 -32px',
        boxSizing: 'content-box'
      },
      feedBackTopContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      responseSelectionText: {
        fontSize: '14px',
        lineHeight: '19px',
        color: '#2d3d49',
        letterSpacing: '0.1px',
        display: 'inline-block',
        marginRight: '20px'
      },
      topResponseSelectionText: {
        fontSize: '13px',
        lineHeight: '18px',
        color: '#767e86',
        letterSpacing: '0.1px',
        display: 'inline-block',
        marginRight: '8px'
      },
      image: {
        width: kIconSize,
        height: kIconSize,
        alignItems: 'center',
        justifyContent: 'center',
        ':hover': {}
      },
      viewImage: {
        width: '16px',
        height: '16px',
        alignItems: 'center',
        justifyContent: 'center'
      },
      iconMarginRight: {
        marginRight: '24px'
      },
      iconMarginRight10: {
        marginRight: '10px'
      },
      iconMarginRightNone: {
        marginRight: '0px'
      },
      button: {
        color: '#4a90e2',
        fontSize: '13px',
        lineHeight: '18px',
        fontWeight: '500',
        textTransform: 'uppercase',
        marginLeft: '8px',
        cursor: 'pointer'
      },
      responseTypeButtonWrapper: {
        display: 'inline-block',
        cursor: 'pointer'
      },
      viewResponseTypeButtonWrapper: {
        display: 'inline-block'
      },
      responseTypeButtonText: {
        color: Colors.responseTypeLabel,
        fontSize: kRecommendedLabelFontSize
      },
      iconsWrapper: {
        display: 'inline-block'
      },
      editSubmissionSection: {
        marginRight: '-20px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      editIconContainer: {
        marginRight: '30px'
      },
      submissionIconContainer: {
        cursor: 'pointer',
        display: 'inline-block',
        position: 'relative'
      },
      selectResponseTypeContainer: {
        float: 'left',
        width: '100%'
      },
      submittedTextContainer: {
        fontSize: '14px',
        fontFamily: 'ProximaNova',
        color: 'rgba(0,0,0,0.8)',
        letterSpacing: '0.1px',
        lineHeight: '19px',
        wordWrap: 'break-word',
        display: 'none'
      },
      showText: {
        display: 'flex'
      },
      marginTop16: {
        marginTop: '16px'
      },
      transitionProp: {
        transition: 'all 0.5s linear'
      },
      hideText: {
        display: 'none'
      },
      cancelButton: {
        width: '94px',
        height: '30px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '2px',
        color: '#4a90e2',
        textTransform: 'uppercase',
        justifyContent: 'center',
        fontSize: '13px',
        lineHieght: '18px',
        fontWeight: '500',
        marginRight: '-14px'
      },
      cancelButtonDefaultState: {
        border: '1px solid white'
      },
      cancelButtonHoverState: {
        border: '1px solid #4a90e2'
      },
      cancelButtonText: {
        marginLeft: '6px',
        marginTop: '2px'
      },
      submittedResponseTextContainer: {
        cursor: 'pointer',
        float: 'left'
      },
      submissionText: {
        marginRight: '8px'
      },
      videoElement: {
        width: '500px',
        display: 'block',
        maxWidth: '100%',
        height: '300px'
      },
      topSelectionFormatContainer: {
        position: 'absolute',
        right: '8px',
        top: '0px',
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: '0.1px',
        color: '#767e86'
      },
      checkboxTextContainer: {
        float: 'left',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      selectedFormatTextColor: {
        color: 'rgb(118,126,134)'
      },
      buttonWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '28px'
      },
      startNextSessionButton: {
        width: '248px',
        height: '52px',
        borderRadius: '2px',
        background: '#0abff1',
        color: 'white',
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: '1px',
        fontWeight: '500',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      },
      posRelative: {
        position: 'relative'
      },
      topZero: {
        top: '0px'
      },
      nextSessionWrapper: {
        fontSize: '14px',
        lineHeight: '19px',
        letterSpacing: '0.1px',
        color: '#7b96ac',
        marginTop: '12px',
        display: 'block',
        textAlign: 'center'
      },
      questionMarks: {
        fontSize: '12px',
        color: '#758da1',
        fontWeight: '500'
      },
      yourResponseLabel: {
        float: 'left',
        color: '#9ea7b1',
        fontSize: '13px',
        letterSpacing: '0.1px',
        textTransform: 'uppercase',
        padding: '7px 0 0'
      },
      displayFlexRow: {
        display: 'flex',
        flexDirection: 'row'
      },
      displayFlexColumn: {
        display: 'flex',
        flexDirection: 'column'
      },
      alignItemsCenter: {
        alignItems: 'center'
      },
      seeSubmissionText: {
        cursor: 'pointer',
        fontSize: '13px',
        lineHeight: '16px',
        color: '#758da1',
        fontWeight: '500',
        letterSpacing: '0.1px',
        textTransform: 'uppercase'
      },
      topRatedSubmissionWrapper: {
        margin: '31px 0 32px'
      },
      topRatedSubmissionTitle: {
        fontSize: '13px',
        lineHeight: '16px',
        fontWeight: '500',
        letterSpacing: '0.1px',
        color: '#9ea7b1',
        marginBottom: '19px',
        textTransform: 'uppercase',
        cursor: 'pointer'
      },
      responseUserInfo: {
        fontSize: '16px',
        lineHeight: '18px',
        color: '#393d45',
        marginBottom: '11px'
      },
      userImage: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        margin: '0 7px'
      },
      responseRow: {
        marginBottom: '24px'
      },
      lastItem: {
        marginBottom: '0px'
      },
      responseText: {
        fontSize: '16px',
        lineHeight: '20px',
        color: '#2b2e35'
      },
      dropDownArrow: {
        marginLeft: '5px'
      },
      instructionContainer: {
        border: '1px solid #dbe2e8',
        borderRadius: '4px',
        padding: '16px 20px',
        marginBottom: '18px'
      },
      instructionTitle: {
        fontSize: '15px',
        lineHeight: '18px',
        color: '#294860',
        fontWeight: 'bold',
        marginBottom: '12px'
      },
      instructionText: {
        fontSize: '15px',
        lineHeight: '17px',
        color: '#294860'
      },
      marginBottom32: {
        marginBottom: '32px'
      },
      subIntroText: {
        marginBottom: '12px'
      },
      actionInfo: {
        marginLeft: '5px'
      },
      questionTextWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        fontFamily: 'ProximaNova'
      },
      feedbackContainerNew: {
        display: 'flex',
        flexDirection: 'column'
      },
      feedbackContainer: {
        display: 'flex',
        aligItem: 'center',
        position: 'absolute',
        bottom: '-62px',
        right: '0px'
      },
      imageContainer: {
        maxWidth: '28px',
        height: '28px',
        border: '2px solid #f9b702',
        borderRadius: '50%',
        overflow: 'hidden'
      },
      feedbackImage: {
        width: '32px',
        height: '32px',
        overflow: 'hidden',
        borderRadius: '50%',
        border: 'solid 2px #f8b602'
      },
      feedbackUserImage: {
        width: '100%',
        borderRadius: '50%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100%'
      },
      feedBackNameImageContainer: {
        display: 'flex',
        alignItems: 'center'
      },
      feedbackTextContainer: {
        marginTop: '10px',
        fontFamily: 'ProximaNova',
        fontSize: '15px',
        lineHeight: '22px',
        color: '#393d45'
      },

      readMoreDots: {
        color: 'rgb(85, 95, 104)'
      },
      readMoreText: {
        color: '#427FDC',
        textTransform: 'lowercase',
        cursor: 'pointer'
      },
      feedbackName: {
        marginLeft: '10px',
        fontFamily: 'ProximaNova',
        fontWeight: '500',
        color: '#566068'
      },
      preStyle: {
        background: 'none',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        font: 'inherit'
      }
    };
  }

  @autobind
  hoverCancelButton(flag) {
    this.setState({
      cancelButtonHovered: flag
    });
  }

  @autobind
  toggleLines(event, index) {
    event.stopPropagation();
    console.log('inside index and readMore.....', index, this.readMoreIndexes);
    const readMoreObejctIndex = this.readMoreIndexes.indexOf(index);
    if (readMoreObejctIndex > -1) {
      this.readMoreIndexes.splice(readMoreObejctIndex, 1);
    } else {
      this.readMoreIndexes.push(index);
    }

    this.setState({
      readMore: !this.state.readMore
    });
  }

  @autobind
  editResponse() {
    this.context.checkForSubmit && this.context.checkForSubmit();
    this.setState({
      isResponseEntered: !this.state.isResponseEntered,
      responseEdited: true
    });
  }

  @autobind
  responseEdited(flag) {
    this.setState({ responseEdited: flag });
  }

  @autobind
  deleteResponse() {
    this.activeSubmissionRef &&
      this.activeSubmissionRef.emptySubmittedResponse &&
      this.activeSubmissionRef.emptySubmittedResponse();
    if (!this.props.actualSubmit)
      this.setState({ deletingResponse: true }, () => this.props.saveResponses(true));
  }

  viewAllResponseIcons() {
    const styles = this.styles();
    const allResponseTypes = this.props.submission.answerTypeSecondary.slice();
    allResponseTypes.unshift(this.props.submission.answerType);
    return this.swapResponseTypes(allResponseTypes).map((rType, index) => (
      <div key={index} style={styles.viewResponseTypeButtonWrapper}>
        {this.renderResponseIcon(rType, '#b1bbc3', true, false)}
      </div>
    ));
  }

  swapResponseTypes(arr) {
    if (arr.length < 3) return arr;
    const match =
      findIndex(arr, item => item === 'AUDIO') > -1 &&
      findIndex(arr, item => item === 'VIDEO') > -1;
    if (match) {
      const audioIndex = findIndex(arr, item => item === 'AUDIO');
      const videoIndex = findIndex(arr, item => item === 'VIDEO');
      const temp = arr[audioIndex];
      arr[audioIndex] = arr[videoIndex];
      arr[videoIndex] = temp;
    }
    return arr;
  }

  @autobind
  resetSelectedResponseType() {
    this.setState({
      selectedResponseType: null
    });
  }

  @autobind
  changeReponseButtonPressed() {
    if (this.props.submission.response) {
      this.props.changeResponseTypePressed(this.props.position, this.resetSelectedResponseType);
    } else {
      this.resetSelectedResponseType();
    }
  }

  responseTypePressed(rType) {
    this.setState({
      selectedResponseType: rType
    });
  }

  @autobind
  // eslint-disable-next-line consistent-return
  renderChangeResponseButton() {
    const styles = this.styles();
    const isSecondaryResponseTypeAvailable =
      this.props.submission.answerTypeSecondary &&
      this.props.submission.answerTypeSecondary.length > 0;
    if (isSecondaryResponseTypeAvailable) {
      return (
        <span style={styles.button} onClick={this.changeReponseButtonPressed}>
          Change
        </span>
      );
    }
  }

  renderTopRatedResponses(topRatedResponses) {
    const styles = this.styles();
    return (
      <div style={[styles.topRatedSubmissionWrapper, styles.displayFlexColumn]}>
        {!this.state.showTopRatedSubmissions ? (
          <div
            style={[styles.seeSubmissionText, styles.displayFlexRow, styles.alignItemsCenter]}
            onClick={this.showTopRatedSubmissions}
          >
            See Top Rated Submissions
            <Icon
              icon="arrow-drop-down"
              fill="#7b96ac"
              size="20px"
              viewBox="0 1 24 24"
              style={styles.dropDownArrow}
            />
          </div>
        ) : (
          <div style={styles.displayFlexColumn}>
            <span
              style={[
                styles.topRatedSubmissionTitle,
                styles.displayFlexRow,
                styles.alignItemsCenter
              ]}
              onClick={this.showTopRatedSubmissions}
            >
              Top Rated Submissions for Reviews
              <Icon
                icon="arrow-drop-up"
                fill="#9ea7b1"
                size="20px"
                viewBox="0 1 24 24"
                style={styles.dropDownArrow}
              />
            </span>
            {topRatedResponses.map((response, index) => (
              <div
                style={[
                  styles.responseRow,
                  styles.displayFlexColumn,
                  index + 1 === topRatedResponses.length ? styles.lastItem : null
                ]}
              >
                <div
                  style={[styles.responseUserInfo, styles.displayFlexRow, styles.alignItemsCenter]}
                >
                  {index + 1}
                  .
                  <img style={styles.userImage} src={response.user.picture} alt="" />{' '}
                  {response.user.name}
                </div>
                <div style={styles.displayFlexRow}>
                  {this.renderResponse(response.answer.response, response.answer.answerType)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderResponseType() {
    const styles = this.styles();
    const submissionResponse = (() => {
      if (
        typeof this.props.submission.response === 'string' &&
        this.props.submission.response.length > 0
      )
        return this.props.submission.response;
      if (this.activeSubmissionRef && this.activeSubmissionRef.getResponse().responseData.response)
        return this.activeSubmissionRef.getResponse().responseData.response;
    })();

    return (
      <div style={styles.spaceBetween}>
        {this.renderSubmissionText(this.state.isResponseEntered, submissionResponse)}
        {this.props.submission.answerTypeSecondary &&
        this.props.submission.answerTypeSecondary.length > 0 &&
        !this.state.isResponseEntered
          ? this.renderResponseFormatText(
              this.state.selectedResponseType,
              this.props.submission.answerTypeSecondary
            )
          : null}
      </div>
    );
  }

  renderResponseFormatText(selectedResponseType) {
    const styles = this.styles();
    return (
      <div style={styles.multipleResponseTypeWrapper}>
        {selectedResponseType ? (
          <div style={styles.selectResponseTypeContainer}>
            <span style={[styles.responseSelectionText, styles.selectedFormatTextColor]}>
              Selected Response Format:
            </span>
            <div style={styles.iconsWrapper}>
              {this.renderResponseIcon(selectedResponseType, '#767e86', false, true)}
            </div>
            {this.renderChangeResponseButton()}
          </div>
        ) : (
          <div style={styles.selectResponseTypeContainer}>
            <div style={styles.responseSelectionText}>Select Response Format: </div>
            <div style={styles.iconsWrapper}>{this.renderAllResponseIcons()}</div>
          </div>
        )}
      </div>
    );
  }

  renderFeedback(feedbackObj, index) {
    const styles = this.styles();
    const readMoreExists = this.readMoreIndexes.indexOf(index) > -1;
    const name = getItemInfo(
      'users',
      feedbackObj.feedbackGivenBy.pid,
      'name',
      this.rerender,
      '...'
    );
    const picture = getItemInfo(
      'users',
      feedbackObj.feedbackGivenBy.pid,
      'picture',
      this.rerender,
      'https://dndw32r4edmw5.cloudfront.net/assets/avatar.jpg'
    );
    const actorType = feedbackObj.feedbackGivenBy.actorType;
    const actorTypeText = actorType && actorType !== 'user' ? actorType.toUpperCase() : '';
    return feedbackObj.feedback !== '' && !!feedbackObj.feedbackGivenBy ? (
      <div style={[styles.feedbackWrapper, index !== 0 ? { marginTop: '7px' } : null]}>
        <div style={styles.feedBackTopContainer}>
          <div style={styles.feedBackNameImageContainer}>
            <img style={styles.feedbackImage} src={picture} alt="" />
            <div style={styles.feedbackName}>
              {name}{' '}
              {actorTypeText && (
                <span
                  style={{
                    display: 'inline-block',
                    fontSize: '12px',
                    letterSpacing: '0.9px',
                    color: '#929fae',
                    fontWeight: 600
                  }}
                >
                  ({actorTypeText} REVIEW)
                </span>
              )}
            </div>
          </div>
        </div>
        <div style={styles.feedbackTextContainer}>
          <pre className="jsTruncateLines-3" style={styles.preStyle}>
            <Truncate
              lines={!readMoreExists && 2}
              ellipsis={
                <span style={styles.readMoreText} onClick={event => this.toggleLines(event, index)}>
                  <span style={styles.readMoreDots}>...</span>
                  read more
                </span>
              }
            >
              {feedbackObj.feedback}
            </Truncate>
          </pre>
        </div>
      </div>
    ) : null;
  }

  renderResponse(response, selectedResponseType) {
    const styles = this.styles();
    let responseView = '';
    if (selectedResponseType === 'TEXT') {
      responseView = <div style={styles.responseText}>{response}</div>;
    } else if (selectedResponseType === 'AUDIO') {
      responseView = (
        <ReactMediaPlayer ref="ReactMediaPlayer" autoPlay={false} src={response} vendor="AUDIO" />
      );
    } else if (selectedResponseType === 'VIDEO') {
      responseView = (
        <video ref="videoPlayer" controls={true} src={response} style={styles.videoElement} />
      );
    } else if (selectedResponseType === 'IMAGE') {
      responseView = <img alt="" src={response} />;
    }
    return responseView;
  }

  renderSubmissionText(isResponseEntered, submissionResponse) {
    const styles = this.styles();

    if (
      this.state.selectedResponseType === 'SINGLE_SELECT' ||
      this.state.selectedResponseType === 'MULTIPLE_SELECT' ||
      this.state.selectedResponseType === 'OPINION_SCALE' ||
      !this.props.isEnrolled
    )
      return null;

    if (
      !this.props.actualSubmit &&
      (submissionResponse && submissionResponse !== '' && submissionResponse.length > 0)
    ) {
      return (
        <div style={[styles.responseTypeWrapper, styles.yourResponseMargin10]}>
          <div style={styles.editSubmissionSection}>
            {this.state.selectedResponseType === 'AUDIO' ||
            this.state.selectedResponseType === 'VIDEO' ||
            this.state.selectedResponseType === 'IMAGE' ||
            this.state.selectedResponseType === 'TEXT' ? (
              <div style={styles.yourResponseLabel}>Your response</div>
            ) : null}
            <Confirmation
              onConfirm={this.deleteResponse}
              confirmBtnProps={{ text: 'Yes, Delete' }}
              title="Delete response?"
              message="Are you sure you want to delete your response?"
              dropdownPlacement="bottomRight"
            >
              <AccentButton
                text="Remove Response"
                icon={{
                  type: 'delete',
                  style: { width: '14px', marginRight: '6px' }
                }}
              />
            </Confirmation>
          </div>
        </div>
      );
    }
    if (
      this.props.actualSubmit &&
      (this.state.selectedResponseType === 'AUDIO' ||
        this.state.selectedResponseType === 'VIDEO' ||
        this.state.selectedResponseType === 'IMAGE' ||
        this.state.selectedResponseType === 'TEXT')
    ) {
      return (
        <div style={[styles.responseTypeWrapper, styles.yourResponseMargin10]}>
          <div style={styles.editSubmissionSection}>
            <div style={styles.yourResponseLabel}>Your response</div>
          </div>
        </div>
      );
    }
  }

  renderAllResponseIcons() {
    const styles = this.styles();
    const allResponseTypes = this.props.submission.answerTypeSecondary.slice();
    allResponseTypes.unshift(this.props.submission.answerType);
    return this.swapResponseTypes(allResponseTypes).map((rType, index) => (
      <div
        key={index + 'response'}
        style={styles.responseTypeButtonWrapper}
        onClick={() => this.responseTypePressed(rType)}
      >
        {this.renderResponseIcon(rType, '#b1bbc3', true, true)}
      </div>
    ));
  }

  renderAnswerComponent() {
    const subType = (this.props.card.resource && this.props.card.resource.type) || null;
    const cardProps = {
      submissionObj: this.props.submission,
      userId: this.props.userId,
      response: this.props.submission.response,
      uploadResponse: this.props.uploadResponse,
      position: this.props.position,
      questionId: this.props.questionId,
      questionObj: this.props.questionObj,
      cardId: this.props.cardId,
      cardName: this.props.cardName,
      card: this.props.card,
      type: this.props.submission.answerType,
      isResponseEntered: this.state.isResponseEntered,
      editResponse: this.editResponse,
      responseEnterChange: this.responseEnterChange,
      isEnrolled: this.props.isEnrolled,
      showEnrollDialog: this.props.showEnrollDialog,
      ref: ref => {
        this.activeSubmissionRef = ref;
      },
      fullScreen: this.props.fullScreen,
      actualSubmit: this.props.actualSubmit,
      deletingResponse: this.state.deletingResponse,
      submission: this.props.submission.answer,
      saveOneResponse: this.props.saveOneResponse,
      totalSubmissions: this.props.totalSubmissions,
      subType,
      isComplete: this.props.isComplete
    };
    switch (this.state.selectedResponseType) {
      case 'OPINION_SCALE':
        return (
          <SurveyOpinionResponse
            {...cardProps}
            responseEdited={this.responseEdited}
            responseEditedFlag={this.state.responseEdited}
          />
        );
      case 'AUDIO':
        return <AudioResponse {...cardProps} successSubmitAudio={this.props.successSubmitAudio} />;
      case 'VIDEO':
        return <VideoResponse {...cardProps} fullScreen={this.props.fullScreen} />;
      case 'FILE':
        return <FileResponse {...cardProps} />;
      case 'TEXT':
        return (
          <TextResponse
            {...cardProps}
            responseEdited={this.responseEdited}
            responseEditedFlag={this.state.responseEdited}
            autoFocus={
              this.state.selectedResponseType === 'TEXT' &&
              this.props.submission.answerTypeSecondary &&
              this.props.submission.answerTypeSecondary.length > 0
            }
          />
        );
      case 'SINGLE_SELECT': {
        return <QuizCard {...cardProps} rType="SINGLE_SELECT" />;
      }
      case 'MULTIPLE_SELECT': {
        return <QuizCard {...cardProps} rType="MULTIPLE_SELECT" />;
      }
      case 'IMAGE':
        return <PictureResponse {...cardProps} />;
      default:
        return null;
    }
  }

  renderResponseIcon(responseType, iconColor, marginRight, clickableIcon) {
    const styles = this.styles();
    switch (responseType) {
      case 'TEXT':
        return (
          <div
            style={[
              clickableIcon ? styles.image : styles.viewImage,
              marginRight
                ? clickableIcon
                  ? styles.iconMarginRight
                  : styles.iconMarginRight10
                : styles.iconMarginRightNone
            ]}
            key={++this.keyIndex}
          >
            <Icon
              icon="text-type"
              fill={
                Radium.getState(this.state, this.keyIndex, ':hover') && clickableIcon
                  ? '#767e86'
                  : iconColor
              }
              size={clickableIcon ? '16px' : '16px'}
              viewBox={clickableIcon ? '4 1 12 17' : '3 2 13 16'}
              className={clickableIcon ? 'responseTypeIcon' : ''}
            />
          </div>
        );
      case 'AUDIO':
        return (
          <div
            style={[
              clickableIcon ? styles.image : styles.viewImage,
              clickableIcon ? styles.iconMarginRight10 : styles.iconMarginRightNone,
              marginRight
                ? clickableIcon
                  ? styles.iconMarginRight
                  : styles.iconMarginRight10
                : styles.iconMarginRightNone
            ]}
            key={++this.keyIndex}
          >
            <IconComp
              type="record"
              fill={
                Radium.getState(this.state, this.keyIndex, ':hover') && clickableIcon
                  ? '#767e86'
                  : iconColor
              }
              size={clickableIcon ? '16px' : '16px'}
              className={clickableIcon ? 'responseTypeIcon' : ''}
            />
          </div>
        );
      case 'VIDEO':
        return (
          <div
            style={[
              clickableIcon ? styles.image : styles.viewImage,
              marginRight
                ? clickableIcon
                  ? styles.iconMarginRight
                  : styles.iconMarginRight10
                : styles.iconMarginRightNone
            ]}
            key={++this.keyIndex}
          >
            <IconComp
              type="video"
              fill={
                Radium.getState(this.state, this.keyIndex, ':hover') && clickableIcon
                  ? '#767e86'
                  : iconColor
              }
              size={clickableIcon ? '16px' : '16px'}
              className={clickableIcon ? 'responseTypeIcon' : ''}
            />
          </div>
        );
      case 'IMAGE':
        return (
          <div
            style={[
              clickableIcon ? styles.image : styles.viewImage,
              marginRight
                ? clickableIcon
                  ? styles.iconMarginRight
                  : styles.iconMarginRight10
                : styles.iconMarginRightNone
            ]}
            key={++this.keyIndex}
          >
            <IconComp
              type="image"
              fill={
                Radium.getState(this.state, this.keyIndex, ':hover') && clickableIcon
                  ? '#767e86'
                  : iconColor
              }
              size={clickableIcon ? '16px' : '16px'}
              className={clickableIcon ? 'responseTypeIcon' : ''}
            />
          </div>
        );
      case 'FILE':
        return (
          <div
            style={[
              clickableIcon ? styles.image : styles.viewImage,
              marginRight
                ? clickableIcon
                  ? styles.iconMarginRight
                  : styles.iconMarginRight10
                : styles.iconMarginRightNone
            ]}
            key={++this.keyIndex}
          >
            <IconComp
              type="file"
              size={clickableIcon ? '16px' : '16px'}
              className={clickableIcon ? 'responseTypeIcon fileIcon' : ''}
              fill={
                Radium.getState(this.state, this.keyIndex, ':hover') && clickableIcon
                  ? '#767e86'
                  : iconColor
              }
            />
          </div>
        );
    }

    return null;
  }

  render() {
    const styles = this.styles();
    const questionObj = this.props.questionObj;
    const card = this.props.card;
    const { topRatedResponses } = this.state;
    const peerGradable = questionObj.gradingScheme === 'PEER_GRADABLE';
    const rawScore = (() => {
      if (
        this.props.card.contributeToSuccessStatus &&
        this.props.card.performance &&
        this.props.card.performance.completionStatus === 'COMPLETE' &&
        this.props.card.performance.successStatus !== 'NA'
      ) {
        return `${Math.round(this.props.questionObj.rawScore)}/`;
      }
      return null;
    })();
    const answer =
      this.props.submission.questionObj.answer && this.props.submission.questionObj.answer[0];
    answer && !answer.feedbacks && (answer.feedbacks = []);
    return (
      <div style={[styles.innerContainer, this.props.isLastItem ? styles.noBorderBottom : null]}>
        {false &&
        peerGradable &&
        card.performance &&
        card.performance.completionStatus !== 'COMPLETE' &&
        !Number.isNaN(card.minReviewCount) ? (
          <div style={[styles.instructionContainer, styles.displayFlexColumn]}>
            <div style={[styles.instructionTitle, styles.displayFlexRow, styles.alignItemsCenter]}>
              How To Complete
              <Icon icon="info" fill="#c8cfd6" size="22px" style={styles.actionInfo} />
            </div>
            <div style={styles.instructionText}>
              You need to review at least {card.minReviewCount} peer submissions to complete this
              lesson.
            </div>
          </div>
        ) : null}
        {peerGradable && false ? (
          <div
            style={[styles.instructionContainer, styles.displayFlexColumn, styles.marginBottom32]}
          >
            <div style={[styles.instructionTitle, styles.displayFlexRow, styles.alignItemsCenter]}>
              Review Criteria
              <Icon icon="info" fill="#c8cfd6" size="22px" style={styles.actionInfo} />
            </div>
            <div style={[styles.instructionText, styles.displayFlexColumn]}>
              <span style={styles.subIntroText}>
                Submission will be graded on the following criteria:
              </span>
              <div style={styles.mainText}>
                <ul>
                  <li className="criteriaLine">
                    Depends on the questions that peers will answer while reviewing (15 points)
                  </li>
                  <li className="criteriaLine">
                    Depends on the questions that peers will answer while reviewing (15 points
                    total)
                  </li>
                  <li className="criteriaLine">
                    Depends on the questions that peers will answer while reviewing (10 points)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ) : null}
        <div style={styles.questionTitleLine}>
          <div style={[styles.mainFont, styles.questionNumber]}>Question {this.props.position}</div>
          {!Number.isNaN(this.props.questionObj.maxScore) &&
          this.props.card.contributeToSuccessStatus ? (
            <div style={styles.questionMarks}>
              ({rawScore}
              {this.props.questionObj.maxScore} POINTS)
            </div>
          ) : null}
        </div>
        <div style={styles.questionTextWrapper} className="BlocksContainer noFontStyle">
          <div
            className="questionText text-view-custom-container"
            style={styles.questionText}
            dangerouslySetInnerHTML={{ __html: this.props.submission.question }}
          />
        </div>
        {peerGradable && topRatedResponses.length > 0
          ? this.renderTopRatedResponses(topRatedResponses)
          : null}
        {this.renderResponseType()}
        {this.renderAnswerComponent()}
        {answer ? (
          <div style={styles.feedbackContainerNew}>
            {answer.feedbacks.map((feedback, index) => this.renderFeedback(feedback, index))}
          </div>
        ) : null}
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

module.exports = SubmissionItem;
